"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDialogStyles = exports.useDictionaryFieldStyles = void 0;
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
exports.useDictionaryFieldStyles = makeStyles_1.default(() => ({
    root: {
        height: 22,
        verticalAlign: 'top',
        '&:before': {
            border: 0,
        },
    },
    input: {
        padding: '2pt',
    },
    disabled: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
    actionButtonGroup: {
        width: 100,
    },
    actionButton: {
        width: 100,
        height: 22,
        padding: '0 10px',
        marginLeft: 3,
        fontSize: '12px',
        fontWeight: 600,
        flexShrink: 0,
    },
}));
exports.useDialogStyles = makeStyles_1.default(() => ({
    form: {
        marginBottom: 25,
    },
    filters: {
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: 10,
    },
    delimiter: {
        width: '100%',
        marginBottom: 65,
    },
    actions: {
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        padding: '10px 24px',
        backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
    buttonLabel: {
        textTransform: 'uppercase',
    },
}));
//# sourceMappingURL=dictionary-field-styles.js.map